// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-area-main-a0BdnO{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;flex-direction:column;height:100%;display:flex;position:relative}.chat-area-main-pc-akEqzG{width:100%}.chat-area-main-mobile-n22ptw{width:100vw}.forbidden-children-pointer-events-ZGQIf3 *{pointer-events:none}.header-node-t5EJBa{z-index:var(--chat-z-index-header,50)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chat-area-main": `chat-area-main-a0BdnO`,
	"chatAreaMain": `chat-area-main-a0BdnO`,
	"chat-area-main-pc": `chat-area-main-pc-akEqzG`,
	"chatAreaMainPc": `chat-area-main-pc-akEqzG`,
	"chat-area-main-mobile": `chat-area-main-mobile-n22ptw`,
	"chatAreaMainMobile": `chat-area-main-mobile-n22ptw`,
	"forbidden-children-pointer-events": `forbidden-children-pointer-events-ZGQIf3`,
	"forbiddenChildrenPointerEvents": `forbidden-children-pointer-events-ZGQIf3`,
	"header-node": `header-node-t5EJBa`,
	"headerNode": `header-node-t5EJBa`
};
export default ___CSS_LOADER_EXPORT___;
